module.exports = __webpack_public_path__ + "img/we-adapt-to-change.fa1c8d37.png";